export function getPropertyRateDisplayPrice(rate: App.PropertyRate): number {
  return rate.luxPlusTotal?.displayPrice ?? rate.total.displayPrice
}

export function getPropertyRateVariantPriceDifference(
  rate: App.PropertyRate,
  selectedRate: App.PropertyRate | undefined,
): number {
  if (!selectedRate || rate.rateId === selectedRate.rateId) {
    return 0
  }

  return getPropertyRateDisplayPrice(rate) - getPropertyRateDisplayPrice(selectedRate)
}
